import { A } from "@solidjs/router";
import { Component, For, Show, JSXElement, onMount } from "solid-js";
import { ArtworkItem, SalonSubmissionAwardGrouping } from "../Types";
import { CMS } from "./cms/cms";
import { Exhibiting } from "./exhibiting";
import { RawHtml } from "./raw-html";
import { Img } from "./universal/image";
import { loadCms } from "../app";
import { createStore } from "solid-js/store";
import { cleanTargetName, slug } from "../library/common";

type AwardGroupingProps ={
    group: SalonSubmissionAwardGrouping;
    primaryArtworkId?: number;
    primaryArtworkText?: string;
    showPrizeMoney?: boolean;
}
export const AwardGrouping : Component<AwardGroupingProps> = (props) => {
    const itemCount = props.group.Items.length;
    const gridItemClass = "grid-item" + (itemCount ? " single" : "");
    const maxWidth = itemCount == 1 ? 900 : itemCount == 2 ? 600 : 360;
    console.log("AwardGrouping", { itemCount });
    const Model = props.group;
    return (
        <>
            <div class="runner-up-grid" style="text-align: center; background-color: #333;">
                <For each={props.group.Items}>{(item) => {
                    const artist = item.FirstName + " " + item.LastName;
                    const award = item.Awards[0];
                    const artistUrl = `/artist/${slug(artist)}/${item.ContestEntrantId}`;
                    const artworkUrl = `/artwork/${slug(artist)}/${slug(item.Title)}/${item.Id}`;
                    return (
                        <div
                            class={gridItemClass}
                            style={{ display: "inline-block", "vertical-align": "top", "text-align": "left", "margin": "10px", "max-width": `${maxWidth}px`, "width": `${maxWidth}px` }}>
                            <div style="position:relative;">
                                <div style={{ "background-color": item.PrimaryImage.DominantColourHexCode || "#000" }}>
                                    <A href={artworkUrl}>
                                        <Img class="no-clicky-for-you"
                                            src={item.PrimaryImage.URL}
                                            naturalWidth={item.PrimaryImage.Width} naturalHeight={item.PrimaryImage.Height}
                                            maxWidth={maxWidth} width={maxWidth}
                                            style={{ "width": maxWidth + "px"}}
                                        />
                                    </A>
                                </div>
                            </div>
                            <div class="didactic" style={{ "width": `${maxWidth}px` }}>
                                <Show when={(item.AwardPrice || 0) > 0}>
                                    <h3 class="purchase-price">
                                        ${item.AwardPrice}
                                    </h3>
                                </Show>
                                <Show when={Model.SubGrouping}>
                                    <h3 class="award">
                                        {award.Award} {award.Amount}
                                    </h3>
                                </Show>
                                <h3 style="font-weight: 600;">
                                    <A href={artistUrl}>
                                        {item.FirstName} {item.LastName}
                                    </A>
                                </h3>
                                <h4>
                                    <A href={artworkUrl}>
                                        <RawHtml value={item.Title} />
                                    </A>
                                </h4>
                                <Show when={item.Year}>
                                    <p>
                                        {item.Year}
                                    </p>
                                </Show>
                                <p>
                                    {item.Medium}
                                </p>
                                <p>
                                    <RawHtml value={item.Measurements} />
                                </p>
                                <Show when={Model.Award.indexOf("Dual Category") >= 0}>
                                    <div>
                                        <label class="header">
                                            Categories entered
                                        </label>
                                        <ul class="list-inline">
                                            <For each={item.Categories}>{(category) =>
                                                <li style="margin-bottom: 10px;">
                                                    <span style="font-family: 'Raleway-Regular'; font-size: 1em;" class="label label-default label-category">{category}</span>
                                                </li>
                                            }</For>
                                        </ul>
                                    </div>
                                </Show>
                            </div>
                        </div>
                    )}
                }</For>
            </div>
        </>
    )
}
type AwardGroupingListProps = {
    children?: JSXElement;
    cmsId?: string;
    showPrizeMoney?: boolean;
    subGroup?: boolean;
    showDivider?: boolean;
    primaryArtworkId?: number;
    primaryArtworkText?: string;
    heading: string;
    subHeading?: string;
    items: SalonSubmissionAwardGrouping[];
}
type State = {
    isContentReady: boolean;
}
export const AwardGroupingList : Component<AwardGroupingListProps> = (props)=> {
    const [state, setState] = createStore<State>({ isContentReady: false });
    const divider = props.subGroup ? "subdivider" : "divider";
    onMount(async () => {
        if (!!props.cmsId) {
            await loadCms([props.cmsId]);
        }
        setState({ isContentReady: true });
    })
    return (
        <>
            <Show when={state.isContentReady}>
                <div>
                    <For each={props.items}>{(group) =>
                        <>
                            <div class={divider}>
                                <a name={cleanTargetName(props.heading)}></a>
                                <h1 style="text-align: center; line-height: 2em;">
                                    {props.heading || group.Award}
                                </h1>
                                <div class="container">
                                    <Show when={props.cmsId}>
                                        <CMS id={props.cmsId as string}>{props.children}</CMS>
                                    </Show>
                                    <Show when={props.children}>
                                        {props.children}
                                    </Show>
                                </div>
                            </div>
                            <div>
                                <AwardGrouping
                                    group={group}
                                    primaryArtworkId={props.primaryArtworkId}
                                    primaryArtworkText={props.primaryArtworkText}
                                    showPrizeMoney={props.showPrizeMoney}
                                />
                            </div>
                        </>
                    }</For>
                </div>
            </Show>
        </>
    )
}